<ng-container *transloco="let t">
  <nz-page-header
    [nzGhost]="false"
    class="page-header"
    [class.side-margin]="!isMobile"
  >
    <nz-page-header-title class="header-title" *ngIf="!simpleTable">
      <span *ngIf="!hideTitle">{{ title | transloco }}</span>
      <div class="filter-tags">
        <div *ngFor="let column of columns">
          <nz-tag
            *ngIf="column.isFilterApplied && column.appliedFilters"
            [nzColor]="getColumnColor(column)"
            nzMode="closeable"
            (nzOnClose)="onRemoveTag(column)"
          >
            <strong>{{ column.name || column.prop | transloco }}</strong>
            <span
              class="filter"
              *ngIf="
                !isDropDownFilter(column) &&
                !isDateColumn(column) &&
                !isUsernameColumn(column)
              "
            >
              <span>{{ column.appliedFilters }} </span>
            </span>
            <span *ngIf="isDropDownFilter(column)">
              <span class="filter" *ngFor="let filter of column.appliedFilters"
                >{{ filter.label }}
              </span>
            </span>
            <span class="filter" *ngIf="isDateColumn(column)">
              <span>
                {{ column.appliedFilters[0] | date }} -
                {{ column.appliedFilters[1] | date }}
              </span>
            </span>
          </nz-tag>
        </div>
      </div>
      <button
        nz-button
        nzType="default"
        *ngIf="customSortFn && rows"
        (click)="customSort()"
      >
        מיין
      </button>
    </nz-page-header-title>
    <nz-page-header-extra class="header-extra">
      <ng-content></ng-content>
    </nz-page-header-extra>
    <nz-page-header-content
      class="header-content"
      [class.simple]="simpleTable"
      [class.auto-height]="autoHeight"
      [class.dialog]="isDialog"
    >
      <nz-table
        #table
        data-testid="crud-table"
        nzBordered
        class="ant-table-ping-left"
        [nzScroll]="isScrollable"
        [nzData]="rows"
        [nzFrontPagination]="false"
        [nzLoading]="isLoading"
        [nzTotal]="totalElements"
        [nzPageSize]="limit"
        [nzPageIndex]="pageNumber"
        [nzShowTotal]="totalTemplate"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[20, 50, 100]"
        nzTableLayout="fixed"
        nzSize="small"
        (nzPageIndexChange)="setPage($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
      >
        <thead>
          <tr>
            <th *ngIf="isSelectable" nzWidth="38px"></th>
            <th *ngIf="expandedRowTemplate" nzWidth="50px"></th>
            <th
              class="header-cell"
              *ngFor="let column of columns | filterBy : ['isVisible'] : true"
              [nzSortDirections]="column.sortDirection"
              [(nzSortOrder)]="column.sortOrder"
              [nzColumnKey]="column.prop"
              [nzShowSort]="!column.hideSort"
              [nzSortFn]="column.sortFn || true"
              [nzFilterFn]="true"
              [nzFilters]="column.filters || []"
              [nzWidth]="column.width"
              nzAlign="right"
              (nzSortOrderChange)="applySort($event, column)"
              (nzFilterChange)="applyFilter($event, column)"
              nzCustomFilter
            >
              {{ column.name || getColumnProp(column) | transloco }}
              <nz-filter-trigger
                #tag
                (nzVisibleChange)="onSearchClick(column, $event)"
                [nzVisible]="
                  column.isSearchVisible && selectedColumn === column
                "
                [nzActive]="isActiveFilter(column)"
                [nzDropdownMenu]="menu"
                [attr.data-testid]="'filter-' + column.prop"
                class="filter-trigger"
                [style.color]="filterIconColor(column, tag.nzActive)"
                *ngIf="!column.hideFilter"
              >
                <i
                  nz-icon
                  [nzType]="isDropDownFilter(column) ? 'filter' : 'search'"
                  class="filter-icon"
                ></i>
              </nz-filter-trigger>
            </th>
            <th
              nzWidth="130px"
              nzLeft
              style="text-align: center"
              *ngIf="!(simpleTable || hideActionsColumn)"
            >
              <div actions class="actions">
                <button nz-button (click)="export()" *ngIf="canExport">
                  <i nz-icon nzType="file-excel" nzTheme="outline"></i>
                </button>

                <button
                  nz-button
                  nz-dropdown
                  nzTrigger="click"
                  [nzDropdownMenu]="columnsmenu"
                  [nzClickHide]="false"
                >
                  <i nz-icon [nzType]="'hdd'"></i>
                </button>
                <nz-dropdown-menu #columnsmenu="nzDropdownMenu">
                  <ul nz-menu class="checkbox-menu">
                    <li
                      nz-menu-item
                      *ngFor="let column of columns"
                      nz-checkbox
                      [(ngModel)]="column.isVisible"
                      (ngModelChange)="toogleColumns()"
                    >
                      {{ column.name || getColumnProp(column) | transloco }}
                    </li>
                  </ul>
                </nz-dropdown-menu>

                <button nz-button (click)="reload()">
                  <i nz-icon nzType="reload" nzTheme="outline"></i>
                </button>
              </div>
            </th>
          </tr>
        </thead>
        <tbody [class.expanded]="expandedRowTemplate">
          <ng-template ngFor let-data [ngForOf]="table.data">
            <tr
              data-testid="crud-row"
              [attr.data-row-id]="data.id"
              [class.heightlight]="data.expand"
              [class.marked]="data.isMarked"
            >
              <td *ngIf="isSelectable">
                <mat-radio-button (change)="onRowSelect(data)">
                </mat-radio-button>
              </td>
              <td [(nzExpand)]="data.expand" *ngIf="expandedRowTemplate"></td>
              <td
                *ngFor="let column of columns | filterBy : ['isVisible'] : true"
              >
                <ng-template [ngIf]="column.type === 'plainText'">{{
                  data[column.prop]
                }}</ng-template>
                <ng-template [ngIf]="column.type === 'object'">{{
                  data[column.prop]
                    ? getColumnObjValue(data[column.prop], column.objectField)
                    : ''
                }}</ng-template>
                <ng-template [ngIf]="column.type === 'pipe'">
                  <span *ngIf="!column.isArray">
                    <nz-avatar
                      [nzSize]="30"
                      nzIcon="user"
                      [nzSrc]="getAvatar(data[column.prop])"
                      *ngIf="isUsernamePipe(column.pipe)"
                      style="margin-left: 5px"
                    ></nz-avatar>
                    <span>{{
                      column.objectField
                        ? column.pipe.transform(
                            getColumnObjValue(
                              data[column.prop],
                              column.objectField
                            )
                          )
                        : column.pipe.transform(data[column.prop])
                    }}</span>
                  </span>
                  <nz-list nzSize="small" *ngIf="column.isArray">
                    <nz-list-item *ngFor="let item of data[column.prop]">
                      <strong>-</strong>
                      <span>
                        {{ column.pipe.transform(item) }}
                      </span>
                    </nz-list-item>
                  </nz-list>
                </ng-template>
                <ng-template
                  [ngIf]="column.type === 'link' && data[column.prop]"
                >
                  <a
                    [routerLink]="displayLink(column.link, data[column.prop])"
                    *ngIf="!column.generateLinkFn"
                    >{{ data[column.prop] }}
                  </a>
                  <a
                    [routerLink]="
                      displayCustomLink(data, column.generateLinkFn)
                    "
                    *ngIf="column.generateLinkFn"
                    >{{ data[column.prop] }}
                  </a>
                </ng-template>
                <ng-template [ngIf]="column.type === 'template'">
                  <ng-container
                    *ngTemplateOutlet="
                      column.cellTemplate;
                      context: { entity: data }
                    "
                  ></ng-container>
                </ng-template>
              </td>
              <td
                nzLeft
                nzAlign="center"
                *ngIf="!(simpleTable || hideActionsColumn)"
              >
                <button
                  *ngFor="let action of actionColumn?.visible"
                  nz-button
                  nzType="default"
                  nzShape="circle"
                  (click)="menuClick(action, data)"
                  [attr.data-testid]="'row-action-' + action.icon"
                  style="margin-left: 10px"
                >
                  <i nz-icon [nzType]="action.icon"></i>
                </button>
                <authority-labs-menu
                  icon="ellipsis"
                  [menuActions]="actionColumn.hidden"
                  buttonStyle="circle"
                  (actionClick)="menuClick($event, data)"
                ></authority-labs-menu>
              </td>
            </tr>
            <tr
              [nzExpand]="data.expand"
              *ngIf="expandedRowTemplate && data.expand"
            >
              <td nzAlign="center">
                <ng-container
                  *ngTemplateOutlet="
                    expandedRowTemplate;
                    context: { data: data }
                  "
                ></ng-container>
              </td>
            </tr>
          </ng-template>
        </tbody>
      </nz-table>
    </nz-page-header-content>
  </nz-page-header>
  <ng-template #totalTemplate let-total>
    <span class="total-rows"
      ><strong
        >סה"כ<ng-container *ngIf="!hideTitle">
          {{ title | transloco }}</ng-container
        >:</strong
      >
      {{ total }}</span
    >
    <span class="total-rows" *ngIf="aggregatedData"
      ><strong>{{ aggregatedDataKey | transloco }}:</strong>
      {{ aggregatedDataValue | currency | negative }}</span
    >
  </ng-template>
</ng-container>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown" *ngIf="selectedColumn">
    <form ngForm class="search-box">
      <div
        *ngIf="
          !isDateColumn(selectedColumn) && !isDropDownFilter(selectedColumn)
        "
      >
        <input
          type="text"
          authorityLabsAutofocus
          nz-input
          name="search"
          data-testid="filter-input"
          [placeholder]="'filter.filterValue' | transloco"
          [(ngModel)]="selectedColumn.appliedFilters"
        />
      </div>
      <div *ngIf="isDateColumn(selectedColumn)">
        <nz-range-picker
          dir="ltr"
          class="date-picker-wrap"
          name="date-picker"
          [nzFormat]="'PP'"
          nzInline
          [(ngModel)]="selectedColumn.appliedFilters"
        ></nz-range-picker>
      </div>
      <div class="drop-down" *ngIf="isDropDownFilter(selectedColumn)">
        <authority-labs-column-filter
          name="drop-down"
          [filters]="selectedColumn.filters"
          [(ngModel)]="selectedColumn.appliedFilters"
        ></authority-labs-column-filter>
      </div>
      <div>
        <button
          nz-button
          nzSize="small"
          type="button"
          (click)="onRemoveTag(selectedColumn)"
        >
          {{ 'button.reset' | transloco }}
        </button>
        <button
          nz-button
          nzSize="small"
          nzType="primary"
          type="submit"
          (click)="search(selectedColumn)"
          data-testid="filter-apply"
          class="search-button"
          [disabled]="!selectedColumn.appliedFilters"
        >
          {{ 'button.apply' | transloco }}
        </button>
      </div>
    </form>
  </div>
</nz-dropdown-menu>
